// extracted by mini-css-extract-plugin
export var active = "_83-a";
export var activeIndicator = "_83-9";
export var disabled = "_83-b";
export var fullWidth = "_83-2";
export var lg = "_83-7";
export var md = "_83-6";
export var redoButtonTabGroup = "_83-0";
export var sm = "_83-5";
export var tabButton = "_83-4";
export var tabButtonsContainer = "_83-1";
export var themeDestructive = "_83-d";
export var themeNormal = "_83-c";
export var themeSuccess = "_83-e";
export var xl = "_83-8";
export var xs = "_83-3";